export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-a-w@2x.2e7a2de6.png";